import { usePropStatusHook } from './prop-status.hook';
import { useTranslation } from 'react-i18next';
import { useRetryPlanDuration } from 'hooks/useRetryPlanDuration';
import { PropChallenge, PropPlan } from 'services/generatedClientFromSwagger';
import { useSelector } from 'react-redux';
import { RootState } from 'store/index';
import { getRetryCost } from '@leverate/common-shared';

export const useEnableRetryLogic = ({ challenge, plan }: { challenge?: PropChallenge; plan?: PropPlan }) => {
    const takenRetries =
        useSelector((store: RootState) => store.prop_myPlans.takenRetries) || ({} as Record<string, boolean>);

    const { t } = useTranslation('prop');
    const { statusTerm } = usePropStatusHook({ challengeStatus: challenge?.challengeStatus });
    const { retryOptions, planId, totalOrderSummaryAmount, endTime } = plan?.pPlan || {};

    const { gapInMilliseconds, isExpirationDateRetryActive } = useRetryPlanDuration({
        endTime: endTime,
        retryExpirationDays: retryOptions?.retryExpirationDays,
    });

    const retryCost = getRetryCost(plan?.pPlan);

    return {
        isRetryActive:
            retryCost > 0 &&
            !takenRetries[planId || ''] &&
            !!challenge?.challengeStatus &&
            statusTerm === t('card.failed') &&
            retryOptions?.isRetryAvailable &&
            (retryOptions?.retryCounter ?? 0) < (retryOptions?.retryLimit ?? 0) &&
            isExpirationDateRetryActive &&
            !retryOptions?.retryNextPlanReference &&
            (totalOrderSummaryAmount ?? 0) > 0,
        gapInMilliseconds,
    };
};
